module.exports = __webpack_public_path__ + "img/imgSLOGAN-da.a9886efa.png";